import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/FlowSensorsFlowMeters.css';
import { FaFilePdf,FaChevronRight,FaEnvelope } from 'react-icons/fa';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import flowMain from '../assets/flow-sensor-image.png'; // Replace with actual image paths
import ultrasonicFlow from '../assets/ultrasonic-flow.png';
import flowSwitch from '../assets/flow-switch.png';
import flowSensor from '../assets/flow-sensor.png';
import FlowPdf from '../assets/Fu-tek_Level & Flow.pdf';
import UltrasonicFlowMeterPdf from '../assets/Ultrasonic FLow Meter(Clamp On Type).pdf';




import gasFlowMonitor from '../assets/Gas-flow-monitor.png'; // replace with correct image path
import GasFlowMonitorPdf from '../assets/Fu-tek_Gas Flow Monitor.pdf'; // replace with correct PDF path



import electromagneticFlowImg from '../assets/electromagneticFlowImg.png';
import ElectromagneticFlowmeterPdf from '../assets/Electromagnetic Flowmeter_Fu-tek_Automation.pdf';



import vortexFlowImg from '../assets/vortexFlowImg.png'; // ✅ Add the correct image path
import VortexFlowmeterPdf from '../assets/Fu_tek_LUGB Vortex Flowmeter.pdf'; // ✅ Add the correct PDF path


import coriolisFlowImg from '../assets/coriolis-mass-flow.png'; // Replace with your image file
import CoriolisMassFlowmeterPdf from '../assets/Fu_Tek_Coriolis Mass Flow Meter.pdf'; // Replace with actual PDF file

export default function FlowSensors() {
  const [activeTab, setActiveTab] = useState('UltrasonicFlowMeter');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="FlowSensor-wrapper">
      <Header />

      {/* Hero Section */}
      <div className="hero-banner22">
        <div className="hero-banner22-content">
          <h1>FLOW SENSORS / FLOW METERS</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Flow Sensors / Flow Meters</span>
          </div>
        </div>
      </div>

      {/* Intro Image + Description */}
      <div className="level-content">
        <div className="level-row">
          <img src={flowMain} alt="Flow Sensors" />
          <div className="level-description">
            <h2>Flow sensors / flow meters</h2>
            <ul>
              <li>For liquids and gases</li>
              <li>Versions for the use in hygienic applications</li>
              <li>Variable process connection using adapters</li>
              <li>Flow monitoring also for aggressive media</li>
            </ul>
            <div className="level-buttons">
              <a href={FlowPdf} target="_blank" rel="noopener noreferrer">
             <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>            
               </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="level-tabs">
          <button className={activeTab === 'UltrasonicFlowMeter' ? 'active' : ''} onClick={() => setActiveTab('UltrasonicFlowMeter')}>Ultrasonic Flow Meter (Clamp on type)</button>
          <button className={activeTab === 'FlowSwitch' ? 'active' : ''} onClick={() => setActiveTab('FlowSwitch')}>Flow Switch</button>
          {/* <button className={activeTab === 'FlowSensor' ? 'active' : ''} onClick={() => setActiveTab('FlowSensor')}>Flow Sensor</button> */}
          {/* <button className={activeTab === 'technical' ? 'active' : ''} onClick={() => setActiveTab('technical')}>Technical Specifications</button> */}
          <button className={activeTab === 'GasFlowMonitor' ? 'active' : ''} onClick={() => setActiveTab('GasFlowMonitor')}>Gas Flow Monitor</button>
          <button className={activeTab === 'ElectromagneticFlowmeter' ? 'active' : ''} onClick={() => setActiveTab('ElectromagneticFlowmeter')}>
  Electromagnetic Flowmeter
</button>
<button
  className={activeTab === 'VortexFlowmeter' ? 'active' : ''}
  onClick={() => setActiveTab('VortexFlowmeter')}
>
  Vortex Flowmeter
</button>
<button
  className={activeTab === 'CoriolisMassFlowMeter' ? 'active' : ''}
  onClick={() => setActiveTab('CoriolisMassFlowMeter')}
>
  Coriolis Mass Flow Meter
</button>


        </div>

        {/* Tab Content */}
        <div className="tab-content">
                    {activeTab === 'technical' && (
            <table className="spec-table">
              <tbody>
                <tr><td>Model</td><td>TRF6-5.1SNO</td></tr>
                <tr><td>Connection Method</td><td>Cable-type</td></tr>
                <tr><td>Installation Method</td><td>Flush</td></tr>
                <tr><td>Size</td><td>Φ6.5</td></tr>
                <tr><td>Detection Distance</td><td>1.5mm ±10%</td></tr>
                <tr><td>Output</td><td>NPN normally open</td></tr>
                <tr><td>Working Voltage</td><td>10–30V DC</td></tr>
                <tr><td>Current</td><td>150mA (Load) / &lt;10mA (Consumption)</td></tr>
                <tr><td>Switch Mode</td><td>2KHz</td></tr>
                <tr><td>Protection</td><td>IP67</td></tr>
                <tr><td>Temp. Range</td><td>-25℃ ~ 75℃</td></tr>
              </tbody>
            </table>
          )}





{activeTab === 'UltrasonicFlowMeter' && (
  <div className="level-product-table">
    <div className="level-product-left">
  <div className="sensor-feature-card">
    <img src={ultrasonicFlow} alt="Ultrasonic Flow Meter (Clamp on type)" />
    <h3>Ultrasonic Flow Meter (Clamp on type)</h3>
    <a href={UltrasonicFlowMeterPdf} target="_blank" rel="noopener noreferrer">
      <button className="download-catalog-btn"><FaFilePdf />Download</button>
    </a>
  </div>
</div>


    <div className="level-card-right">
      <table className="level-spec-table">
        <tbody>
          <tr><td>Measurement Type</td><td>Non-contact clamp-on</td></tr>
          <tr><td>Pipe Size</td><td>DN15 to DN6000 mm</td></tr>
          <tr><td>Media</td><td>Water, Sea Water, Lubrication Oil, Edible Oil</td></tr>
          <tr><td>Linearity</td><td>Better than 0.5%</td></tr>
          <tr><td>Accuracy</td><td>±1% FS</td></tr>
          <tr><td>Output</td><td>4–20mA, RS485, Modbus, Relay (NO + NC)</td></tr>
          <tr><td>Supply Voltage</td><td>24V DC / 230V AC</td></tr>
          <tr><td>Display</td><td>2-line, 16-character display (Flow, Velocity, Totalizer)</td></tr>
          <tr><td>Data Storage</td><td>Built-in memory</td></tr>
          <tr><td>Protection</td><td>IP65</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}












{activeTab === 'FlowSwitch' && (
  <>
    {/* Card 1: Flow Switch */}
    <div className="level-product-table">
      <div className="level-product-left">
        <div className="sensor-feature-card">
          <img src={flowSwitch} alt="Flow Switch" />
          <h3>Flow Switch</h3>
          <a href={FlowPdf} target="_blank" rel="noopener noreferrer">
            <button className="download-catalog-btn"><FaFilePdf />Download</button>
          </a>
        </div>
      </div>

      <div className="level-card-right">
        <table className="level-spec-table">
          <tbody>
            <tr><td>Media</td><td>Gas, Liquid</td></tr>
            <tr><td>Applications</td><td>Pneumatic & hydraulic systems, circulating water, cutting fluid, lubricating oil flow detection, pump idling protection</td></tr>
            <tr><td>Signal Output</td><td>PNP, NPN, Relay (NO + NC)</td></tr>
            <tr><td>Liquids</td><td>Setting range [cm/s]: 3...300</td></tr>
            <tr><td>Gases</td><td>Setting range [cm/s]: 200...3000</td></tr>
            <tr><td>Repeatability [cm/s]</td><td>1...5</td></tr>
            <tr><td>Probe</td><td>SS316L</td></tr>
            <tr><td>Shell</td><td>SS304</td></tr>
            <tr><td>Supply Voltage</td><td>18 – 36V DC</td></tr>
            <tr><td>Temperature Range</td><td>-20°C to 100°C</td></tr>
            <tr><td>Process Connection</td><td>1/4” BSP (M)</td></tr>
            <tr><td>Electrical Connection</td><td>M12 Plug-in</td></tr>
            <tr><td>Protection</td><td>IP67</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    {/* Card 2: Flow Sensor */}
    <div className="level-product-table">
      <div className="level-product-left">
        <div className="sensor-feature-card">
          <img src={flowSensor} alt="Flow Sensor" />
          <h3>Compact Flow Sensor with Display</h3>
          <a href={FlowPdf} target="_blank" rel="noopener noreferrer">
            <button className="download-catalog-btn"><FaFilePdf />Download</button>
          </a>
        </div>
      </div>

      <div className="level-card-right">
        <table className="level-spec-table">
          <tbody>
            <tr><td>Description</td><td>One model for multiple pipe diameters; measures both flow and temperature</td></tr>
            <tr><td>Flow Range</td><td>0.01 – 2.0 m/s (Water)</td></tr>
            <tr><td>Media</td><td>Water; Glycol Solutions; Air; Oils</td></tr>
            <tr><td>Medium Temperature</td><td>-20°C to 90°C</td></tr>
            <tr><td>Signal Output</td><td>Analog (4-20mA), Switching: PNP/NPN NO + NC</td></tr>
            <tr><td>Accuracy</td><td>±2% of the measuring range</td></tr>
            <tr><td>Probe</td><td>SS316L</td></tr>
            <tr><td>Shell</td><td>SS304</td></tr>
            <tr><td>Supply Voltage</td><td>18 – 36 VDC</td></tr>
            <tr><td>Process Connection</td><td>1/4″ BSP (M)</td></tr>
            <tr><td>Flow Display</td><td>Color Crystal Display</td></tr>
            <tr><td>Electrical Connection</td><td>M12 Connection</td></tr>
            <tr><td>Protection</td><td>IP67</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </>
)}









{activeTab === 'GasFlowMonitor' && (
  <div className="level-product-table">
    {/* Left Side Card with Image + Title + Download */}
    <div className="level-product-left">
  <div className="sensor-feature-card">
    <img src={gasFlowMonitor} alt="Gas Flow Monitor" />
    <h3>Gas Flow Monitor</h3>
    <a href={GasFlowMonitorPdf} target="_blank" rel="noopener noreferrer">
      <button className="download-catalog-btn"><FaFilePdf />Download</button>
    </a>
  </div>
</div>







    {/* Right Side Table with updated specs */}
    <div className="level-card-right">
      <table className="level-spec-table">
        <tbody>
          <tr><td>Measuring Medium</td><td>Air, Nitrogen, Hydrogen, Oxygen</td></tr>
          <tr><td>Medium Temperature</td><td>–10°C ~ 60°C</td></tr>
          <tr><td>Detection Method</td><td>Thermal</td></tr>
          <tr><td>Rated Flow Range</td><td>100 / 300 / 400 / 800 / 1000 (unit SLM)</td></tr>
          <tr><td>Range Ratio</td><td>50:1</td></tr>
          <tr><td>Pressure Resistant</td><td>Maximum 0.2~2MPa (depends on flow range)</td></tr>
          <tr><td>Voltage</td><td>DC 24V</td></tr>
          <tr><td>Accuracy</td><td>± 2%FS</td></tr>
          <tr><td>Unit</td><td>L/min (customized)</td></tr>
          <tr><td>Output Method</td><td>4~20mA / RS485</td></tr>
          <tr><td>Outgoing Method</td><td>Straight out, Aviation</td></tr>
          <tr><td>Installation Method</td><td>PT1/2 or PT3/4 external thread (depends on flow range)</td></tr>
          <tr><td>Shell Material</td><td>Polyester plastic</td></tr>
          <tr><td>Base Material</td><td>Aluminum alloy</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}


{activeTab === 'ElectromagneticFlowmeter' && (
  <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={electromagneticFlowImg} alt="Electromagnetic Flowmeter" />
        <h3>Electromagnetic Flowmeter</h3>
        <a href={ElectromagneticFlowmeterPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>

    <div className="level-card-right">
      <table className="level-spec-table">
        <tbody>
          <tr><td>Nominal Diameter (mm)</td><td>Pipeline PTFE lining: DN10–DN600</td></tr>
          <tr><td>Special Specification</td><td>Pipeline rubber lining: DN65–DN2000</td></tr>
          <tr><td>Repeatability Error</td><td>±0.1% of measured value</td></tr>
          <tr><td>Accuracy Class</td><td>Level 0.5, Level 1.0</td></tr>
          <tr><td>Measured Medium Temp.</td>
            <td>
              Regular rubber lining: -20°C ~ +60°C<br/>
              High temp. rubber lining: -20°C ~ +90°C<br/>
              PTFE lining: -30°C ~ +120°C<br/>
              High temp. PTFE lining: -20°C ~ +160°C
            </td>
          </tr>
          <tr><td>Signal Output</td><td>4–20mA, pulse/frequency, control level</td></tr>
          <tr><td>Communication Output</td><td>RS485, Modbus, HART, Profibus-DP</td></tr>
          <tr><td>Power Supply</td><td>220VAC ±15% or 24VDG, ripple W5%</td></tr>
          <tr><td>Connection Type</td><td>ANSI150 flanged</td></tr>
          <tr><td>Protection Grade</td><td>IP65 (up to IP68 for special orders)</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}




{activeTab === 'VortexFlowmeter' && (
  <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={vortexFlowImg} alt="Vortex Flowmeter" />
        <h3>Vortex Flowmeter</h3>
        <a href={VortexFlowmeterPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>

    <div className="level-card-right">
<table className="level-spec-table">
  <tbody>
    <tr><td>Measured Medium</td><td>Medium and high velocity mediums such as steam, compressed air, coal-to-gas and liquid.</td></tr>
    <tr><td>Meter Diameter & Connection Mode</td><td>Flange & Clamp Type: DN15–DN300</td></tr>
    <tr><td>Accuracy Level</td><td>Liquid: ±1%; Gas or Steam: ±1.5%, ±1%</td></tr>
    <tr><td>Range Ratio</td><td>1:10; 1:15; 1:20</td></tr>
    <tr><td>Material of Sensor</td><td>304 Stainless Steel, 316 (L) Stainless Steel</td></tr>
    <tr><td>Service Conditions</td>
      <td>
        Medium Temperature: -40°C ~ +250°C (opt. up to 350°C)<br />
        Ambient Temp: -20°C ~ +60°C<br />
        Relative Humidity: 5% ~ 90%<br />
        Atmospheric Pressure: 86 kPa ~ 106 kPa
      </td>
    </tr>
    <tr><td>Value Output Function</td><td>Pulse signal, 4–20mA signal</td></tr>
    <tr><td>Communication Output Function</td><td>RS485 communication, etc</td></tr>
    <tr><td>Explosion-Proof Grade</td><td>Exd IIC T6 Gb</td></tr>
    <tr><td>IP Grade</td><td>IP65 or more (customizable)</td></tr>
  </tbody>
</table>

    </div>
  </div>
)}

{activeTab === 'CoriolisMassFlowMeter' && (
  <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={coriolisFlowImg} alt="Coriolis Mass Flow Meter" />
        <h3>Coriolis Mass Flow Meter</h3>
        <a href={CoriolisMassFlowmeterPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>

    <div className="level-card-right">
      <table className="level-spec-table">
        <tbody>
          <tr><td>Pipeline Diameter</td><td>DN3–DN200</td></tr>
          <tr><td>Flow Measurement Accuracy</td><td>0.1%, 0.15%, 0.2%</td></tr>
          <tr><td>Repeatability</td><td>0.05%</td></tr>
          <tr><td>Density Measurement Range</td><td>0 &lt; ρ &lt; 5g/cm³</td></tr>
          <tr><td>Density Measurement Accuracy</td><td>±0.001g/cm³</td></tr>
          <tr><td>Temperature Measurement Range</td><td>-200°C ~ 350°C</td></tr>
          <tr><td>Temperature Measurement Accuracy</td><td>±1°C</td></tr>
          <tr><td>Measured Medium Temperature</td><td>-50°C ~ 300°C</td></tr>
          <tr><td>Applicable Ambient Temperature</td><td>-30°C ~ 70°C</td></tr>
          <tr><td>Measuring Tube Material</td><td>316L, Hastelloy Alloy</td></tr>
          <tr><td>Explosion-Proof Rating</td><td>Exd[ib]IICT1~T6Gb (Explosion-proof)</td></tr>
          <tr><td>Ingress Protection Rating</td><td>IP67</td></tr>
          <tr><td>Output Signal</td>
            <td>4–20mA, 0–10kHz Frequency Signal, Pulse Equivalent Signal, RS485, HART</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)}



        </div>
      </div>

      <Footer />
    </div>
  );
}
